import React from "react";
import { Text, View, TouchableOpacity, Image, Platform } from "react-native";
import Glob from "src/globalConstants";
import Rex from "src/globalState";

const { width: widthWithMargins } = Glob.get("dimensions");
const ICON_SIZE = Math.min(0.07 * widthWithMargins, 42);

export default function ChildDropdown({
  visible = false,
  tcChildren = [],
  onClose = () => {},
  onSelectChild = () => {}
}) {
  const renderChildCircle = (child, size = 28, style = {}) => {
    if (!!child.profile_photo && child.profile_photo.includes("http")) {
      return (
        <Image
          source={{ uri: child.profile_photo }}
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            backgroundColor: "#f0f0f0",
            borderWidth: 1.4,
            borderColor: "white",
            ...style
          }}
        />
      );
    }

    return (
      <View
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: Rex.getConfig()?.colors?.background || "#333",
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1.4,
          borderColor: "white",
          ...style
        }}
      >
        <Text
          style={{
            fontSize: size * 0.35,
            fontWeight: "bold",
            color: "white"
          }}
        >
          {(child.first_name || " ").charAt(0)}
          {(child.last_name || " ").charAt(0)}
        </Text>
      </View>
    );
  };

  if (!visible || !tcChildren || tcChildren.length <= 1) {
    return null;
  }

  return (
    <>
      <TouchableOpacity
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999999998
        }}
        activeOpacity={1}
        onPress={onClose}
      />
      <View
        style={{
          position: "absolute",
          top: Glob.get("navBarHeight"),
          right: ICON_SIZE + 20,
          backgroundColor: "white",
          borderRadius: 12,
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.25,
          shadowRadius: 8,
          elevation: 5,
          zIndex: 999999999,
          minWidth: 200,
          maxWidth: 280
        }}
        onMouseEnter={
          Platform.OS === "web"
            ? () => {} // Keep dropdown open on hover
            : undefined
        }
        onMouseLeave={Platform.OS === "web" ? onClose : undefined}
      >
        <View style={{ padding: 12 }}>
          {tcChildren.map((child, index) => (
            <TouchableOpacity
              key={child.id || index}
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingVertical: 8,
                paddingHorizontal: 8,
                borderRadius: 8,
                marginBottom: index < tcChildren.length - 1 ? 2 : 0
              }}
              onPress={() => {
                onClose();
                onSelectChild(child);
              }}
            >
              {renderChildCircle(child, 28)}
              <Text
                style={{
                  marginLeft: 10,
                  fontSize: 13,
                  color: "#333",
                  fontWeight: "500"
                }}
              >
                {child.first_name} {child.last_name}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </>
  );
}
